import { FC, PropsWithChildren } from 'react';

type TableCaptionProps = { rowHeight: number } & PropsWithChildren;

export const TableCaption: FC<TableCaptionProps> = ({ rowHeight, children }) => {
  return (
    <caption style={{ height: `${rowHeight}px` }} className='rounded-t-lg border border-b-0 border-secondary-border bg-white-100 px-6 py-5 text-primary-900'>
      {children}
    </caption>
  );
};
